"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  container: 'sa-resource-labels-header-class',
  headerClass: 'header-class',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8'
};
exports.classes = classes;